import React from 'react';
// import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import CallToAction from '../../components/CallToAction';

const UnexpectedError = (props) => (
  <div className="unexpected-error">
    <Header as="h1">
        Thank you for your request
    </Header>
    <div className="red-box error">
      <p>The information you provided <b>does not match</b> our records.</p>
    </div>
    <p>Code: {props.error || ''}</p>
    <CallToAction id={ 5 }/>
  </div>
);

export default UnexpectedError;
